var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25410_5611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25684 3.66425C8.04204 3.37189 7.70092 3.19922 7.33813 3.19922H2.75668C2.20578 3.19922 1.75918 3.64581 1.75918 4.19672L1.75916 5.19422L1.75914 18.5892C1.75914 19.2188 2.26953 19.7292 2.89914 19.7292H21.1391C21.7687 19.7292 22.2791 19.2188 22.2791 18.5892V6.33422C22.2791 5.70461 21.7687 5.19422 21.1391 5.19422H9.95794C9.59516 5.19422 9.25404 5.02155 9.03924 4.72919L8.25684 3.66425Z",
    fill: "#9DB2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.619141 7.75922C0.619141 7.12961 1.12954 6.61922 1.75914 6.61922H22.2791C22.9087 6.61922 23.4191 7.12961 23.4191 7.75922V20.0142C23.4191 20.6438 22.9087 21.1542 22.2791 21.1542H1.75914C1.12954 21.1542 0.619141 20.6438 0.619141 20.0142V7.75922Z",
    fill: "#B6C6F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25410_5611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.214844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeFolder);
export default __webpack_public_path__ + "static/media/tree-folder.59a51bd4.svg";
export { ForwardRef as ReactComponent };